import moment from "moment";
import AdminBadge from "../_components/AdminBadge";
import { cellClass, stickyCellClass } from "../_components/AdminTable";
import AdminRowActions, { EditLink, ScheduleLink } from "../_components/AdminRowActions";

const DriverItem = ({
  drivers: { _id, name, email, phone, date, isfulltime, isactive },
  count,
}) => (
  <tr>
    <td className={cellClass}>{count + 1}</td>
    <td className={cellClass}>{name}</td>
    <td className={cellClass}>{email}</td>
    <td className={cellClass}>{phone || "-"}</td>
    <td className={cellClass}>
      <AdminBadge tone={isfulltime ? "info" : "purple"}>{isfulltime ? "Full Time" : "Part Time"}</AdminBadge>
    </td>
    <td className={cellClass}>
      <AdminBadge tone={isactive ? "success" : "neutral"}>{isactive ? "Active" : "Inactive"}</AdminBadge>
    </td>
    <td className={`${cellClass} tw:whitespace-nowrap`}>{moment(date).locale("en").format("YYYY/MM/DD")}</td>
    <td className={stickyCellClass}>
      <AdminRowActions>
        <ScheduleLink to={`/admin/driverlist/${_id}/schedule`} label="View driver schedule" />
        <EditLink to={`/admin/driverlist/edit/${_id}`} label="Edit driver" />
      </AdminRowActions>
    </td>
  </tr>
);

export default DriverItem;
